import { mapActions, mapGetters } from 'vuex'
import DOMAIN_SEARCH from '@/graphql/DOMAIN_SEARCH.gql'
import DOMAIN_TLDS from '@/graphql/GET_DOMAIN_PRODUCT_TLDS.gql'
import SET_DOMAIN_NAME from '@/graphql/SET_DOMAIN_NAME.gql'

const domainRegistrationMixin = {
  data () {
    return {
      searchTerm: '',
      domainsFound: [],
      exactMatch: false,
      secondLevelDomain: '',
      tld: null,
      maxSuggestions: 25,
      searchError: false
    }
  },
  computed: {
    ...mapGetters('domainService', ['hasPendingDomain', 'hasPendingDomainSelection', 'getSearchTerm', 'isSearching', 'getTlds'])
  },
  watch: {
    isSearching: {
      handler (newValue) {
        if (newValue === true && (this.searchTerm !== this.getSearchTerm || this.searchError === true)) {
          this.searchTerm = this.getSearchTerm
          var search = []
          this.secondLevelDomain = ''
          this.tld = null
          this.searchError = false
          this.exactMatch = false

          if (this.searchTerm.indexOf('://') > -1) {
            search = this.searchTerm.split('/')[2]
          } else {
            search = this.searchTerm.split('/')[0]
          }

          // look for provided tld if any
          if (this.searchTerm.indexOf('.') > -1) {
            search = search.split('.', 2)
            this.secondLevelDomain = search[0]
            this.tld = search[1]
          } else {
            this.secondLevelDomain = search
          }
          this.getDomainCheck()
        } else {
          this.toggleSearchingStatus(false)
        }
      }
    }
  },
  methods: {
    ...mapActions('domainService', ['toggleSearchingStatus', 'setTlds']),
    async getDomainCheck () {
      try {
        const { data } = await this.$apollo.query({
          query: DOMAIN_SEARCH,
          variables: {
            secondLevelDomain: this.secondLevelDomain,
            tlds: this.getTlds
          },
          fetchPolicy: 'network-only'
        })
        // Extract returned domains check if exact match
        this.domainsFound = this.parseSearchDomainResult(data)
        this.toggleSearchingStatus(false)
        return true
      } catch (err) {
        this.searchError = true
        this.toggleSearchingStatus(false)
        return err
      }
    },
    parseSearchDomainResult (data) {
      const domainList = []
      let validDomain = !(this.tld === null)
      for (const i in data.domainCheck) {
        if (!validDomain) {
          this.searchTerm = data.domainCheck[i].domainName
          validDomain = true
        }

        if (data.domainCheck[i].domainName === this.searchTerm) {
          if (data.domainCheck[i].available === true) {
            this.exactMatch = true
          }
        } else {
          if (data.domainCheck[i].available === true) {
            domainList.push({ name: data.domainCheck[i].domainName, term: data.domainCheck[i].terms })
          }
        }
      }
      let i = 0

      while (domainList.length < this.maxSuggestions && i < data.domainSpin.length) {
        if (!validDomain) {
          if (data.domainSpin[i].domainName.includes(this.searchTerm)) {
            this.searchTerm = data.domainSpin[i].domainName
            validDomain = true
          }
        }

        if (domainList.length < this.maxSuggestions && data.domainSpin[i].available === true && !domainList.some(item => item.name === data.domainSpin[i].domainName)) {
          domainList.push({ name: data.domainSpin[i].domainName, term: data.domainSpin[i].terms })
        }
        i++
      }
      return domainList
    },
    async getDomainProductTlds (tenantId = null) {
      try {
        const { data } = await this.$apollo.query({
          query: DOMAIN_TLDS,
          variables: {
            tenantId: tenantId
          },
          fetchPolicy: 'network-only'
        })
        if (data.domainProductList) {
          return data.domainProductList
        }
        return null
      } catch (err) {
        return null
      }
    },
    async setTldsByTenant (tenantId = null) {
      if (this.getTlds.length === 0) {
        var results = await this.getDomainProductTlds(tenantId)
        if (results !== null) {
          var tlds = []
          for (var i in results) {
            tlds.push(results[i].name)
          }
          this.setTlds(tlds)
        }
      }
    },
    async registerDomainName (domainRegistrationId, domainName, contacts, isPrimaryDomain) {
      var contactList = []

      for (const i in contacts) {
        if (contacts[i].firstName !== '' && contacts[i].lastName !== '') {
          const parsedInfo = {
            title: contacts[i].title,
            firstName: contacts[i].firstName,
            lastName: contacts[i].lastName,
            companyName: contacts[i].companyName,
            companyPositionHeld: contacts[i].companyPositionHeld,
            addressLine1: contacts[i].addressLine1,
            addressLine2: contacts[i].addressLine2,
            city: contacts[i].city,
            countryCode: contacts[i].countryCode,
            emailAddress: contacts[i].emailAddress,
            telephoneNumber: contacts[i].telephoneNumber,
            faxNumber: contacts[i].faxNumber,
            postalCode: contacts[i].postalCode,
            contactType: contacts[i].contactType
          }

          if (contacts[i].countryCode === 'US') {
            parsedInfo.province = ''
            parsedInfo.state = contacts[i].state
          } else {
            parsedInfo.province = contacts[i].province
            parsedInfo.state = ''
          }
          contactList.push(parsedInfo)
        }
      }
      try {
        const { data } = await this.$apollo.mutate({
          mutation: SET_DOMAIN_NAME,
          variables: {
            domainRegistrationId: domainRegistrationId,
            domainName: domainName,
            contacts: contactList,
            isPrimaryDomain: isPrimaryDomain
          }
        })
        return true
      } catch (err) {
        return false
      }
    }
  }
}

export default domainRegistrationMixin
